import { ThemeOptions } from '@common/utils/styles'

const globalTheme: ThemeOptions = {
  typography: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: 14,
    h1: {
      fontWeight: 500,
      fontSize: '70px',
    },
    h2: {
      fontWeight: 500,
      fontSize: '60px',
    },
    h3: {
      fontWeight: 400,
      fontSize: '50px',
    },
    h4: {
      fontWeight: 400,
      fontSize: '35px',
    },
    h5: {
      fontWeight: 400,
      fontSize: '25px',
    },
    h6: {
      fontWeight: 400,
      fontSize: '22px',
    },
    body1: {
      fontWeight: 400,
    },
    body2: {
      fontWeight: 400,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 400,
          textTransform: 'capitalize',
          borderRadius: '5px',
        },
        sizeSmall: {
          // borderRadius: "22px",
        },
        sizeLarge: {
          borderRadius: '5px',
          fontSize: '26px',
          padding: '6px 30px',
        },
      },
    },
  },
}

export default globalTheme
